import { asset } from "../lib/cdn.ts";

const clientLogos = [
  asset("/images/clients/full/mkit.webp"),
  asset("/images/clients/full/kenaz.webp"),
  asset("/images/clients/full/carelend.webp"),
  asset("/images/clients/full/torque.webp"),
  asset("/images/clients/full/cl-bildung.webp"),
  asset("/images/clients/full/sfndy.webp"),
  asset("/images/clients/full/qimmmah.webp"),
];

/** Cycle client marks to fill scroll-spine product logo grids (12 slots). */
export const logoGrid = Array.from(
  { length: 12 },
  (_, i) => clientLogos[i % clientLogos.length],
);

export const media = {
  origin: "https://xattir.com",
  ogImage: "/images/og-image.jpg",
  contactCover: asset("/images/contact.webp"),
  projectsMore: [
    asset("/images/work/marquee/mkit.webp"),
    asset("/images/work/marquee/kenaz.webp"),
    asset("/images/work/marquee/carelend.webp"),
    asset("/images/work/marquee/torque.webp"),
    asset("/images/work/marquee/cl-bildung.webp"),
    asset("/images/work/marquee/sfndy.webp"),
    asset("/images/work/marquee/qimmmah.webp"),
  ],
  /** Locale-neutral service card imagery (generated dark editorial stills). */
  services: {
    /** Full-bleed Services section backdrop (blurred plane — not Work collage). */
    splash: asset("/images/services/splash.webp"),
    digital: asset("/images/services/digital.webp"),
    product: asset("/images/services/product.webp"),
    mobile: asset("/images/services/mobile.webp"),
    design: asset("/images/services/design.webp"),
    ai: asset("/images/services/ai.webp"),
    systems: asset("/images/services/systems.webp"),
    scale: asset("/images/services/scale.webp"),
  },
  caseStudies: {
    mkit: asset("/images/work/marquee/mkit-detail.webp"),
    kenaz: asset("/images/work/marquee/kenaz-detail.webp"),
    carelend: asset("/images/work/marquee/carelend-detail.webp"),
    torque: asset("/images/work/marquee/torque-live.webp"),
    "cl-bildung": asset("/images/work/marquee/cl-bildung.webp"),
    sfndy: asset("/images/work/marquee/sfndy-tour.webp"),
    qimmmah: asset("/images/work/marquee/qimmmah-tech.webp"),
  },
  projects: {
    // Live UI uses desktop `work_cover_*.webp` everywhere. `*_mobile.jpg` stay
    // on disk unused; coverMobile mirrors cover so schema/locale parity hold.
    "case-1": {
      url: "https://new.mkiteg.com/",
      cover: asset("/images/work_cover_1.webp"),
      coverMobile: asset("/images/work_cover_1.webp"),
      slide: "slide1",
    },
    "case-2": {
      url: "https://kenazadvisors.com/",
      cover: asset("/images/work_cover_2.webp"),
      coverMobile: asset("/images/work_cover_2.webp"),
      slide: "slide2",
    },
    "case-3": {
      url: "https://carelend.xattir.com/en",
      cover: asset("/images/work_cover_3.webp"),
      coverMobile: asset("/images/work_cover_3.webp"),
      slide: "slide3",
    },
    "case-4": {
      url: "#",
      /* Thumb / side / fake-thumb: soft multi-device still — NOT the old collage
       * with baked-in “and more” type (crops to illegible “d mo” on mobile). */
      cover: asset("/images/work_cover_4_bridge.webp"),
      coverMobile: asset("/images/work_cover_4_bridge.webp"),
      plane: asset("/images/work_cover_4_bridge.webp"),
      /** Same still as plane — melt / thumb / THREE morph target (no dark plate). */
      bridge: asset("/images/work_cover_4_bridge.webp"),
      slide: "slide4",
    },
  },
  products: {
    productA: { video: asset("/videos/products1.mp4"), logos: logoGrid },
    productB: { video: asset("/videos/products2.mp4"), logos: logoGrid },
  },
  offices: [
    {
      code: "CAI, EGYPT",
      phones: [
        {
          label: "+20 10 0997 6617",
          href: "+201009976617",
          whatsapp: true,
        },
      ],
      email: "info@xattir.com",
    },
  ],
  markets: {
    eg: { lat: 30.0444, lng: 31.2357 },
    kw: { lat: 29.3759, lng: 47.9774 },
    ae: { lat: 25.2048, lng: 55.2708 },
    sa: { lat: 24.7136, lng: 46.6753 },
    us: { lat: 40.7128, lng: -74.006 },
    de: { lat: 52.52, lng: 13.405 },
    dk: { lat: 55.6761, lng: 12.5683 },
  },
} as const;
